import React from 'react'; 
import SpecificComponent from './SpecificComponent'

export default class TestChild extends SpecificComponent{
    constructor(props){
        super(props);
    }



    componentDidMount(){
        // console.log('Testing dictionary 222 = ', this.dictionary)
        // console.log('props 222 level = ', this.props.testProp )
    }


    render(){
        return (
            <div>
                he he heee!!!! <span>{this.dictionary.label1}</span>
            </div>
        );
    }


}  // end class